/**
 * La webmail in una finestra a parte (4/11/2026, «fai sì che usi tutto lo spazio disponibile a schermo e ci
 * sia un bottone "Apri in una nuova schermata"»): la stessa pagina Posta all'indirizzo /posta/finestra,
 * senza menu laterale e testata del gestionale. Stessa sessione e stesse regole: la rotta passa dagli
 * stessi controlli di main.tsx, e l'API decide come per /posta.
 */

export const PERCORSO_FINESTRA_POSTA = '/posta/finestra'

/** Nome fisso della finestra: il secondo clic ritrova quella gia' aperta invece di aprirne un'altra. */
export const NOME_FINESTRA_POSTA = 'cidis-posta'

/** La pagina Posta, nel gestionale o nella finestra a parte. */
export function ePaginaPosta(percorso: string): boolean {
  return percorso === '/posta' || percorso === PERCORSO_FINESTRA_POSTA
}

/**
 * Dentro la finestra della posta un collegamento alla Posta (il riquadro di un'email arrivata) resta nella
 * finestra; tutti gli altri portano al gestionale, anche li'.
 */
export function restaNellaFinestra(dove: string, percorso: string): string {
  if (percorso !== PERCORSO_FINESTRA_POSTA) return dove
  return /^\/posta(?=$|[?#])/.test(dove) ? PERCORSO_FINESTRA_POSTA + dove.slice('/posta'.length) : dove
}

/**
 * Apre la finestra della posta, grande quanto lo schermo, o riporta in primo piano quella gia' aperta.
 * window.open con l'indirizzo ricaricherebbe la finestra esistente, e una risposta a meta' andrebbe persa:
 * prima la si cerca per nome, senza indirizzo, e la si porta alla posta solo se e' nuova o altrove.
 * Falso se il browser ha bloccato la finestra.
 */
export function apriFinestraPosta(): boolean {
  const misure = `popup=yes,left=0,top=0,width=${window.screen.availWidth},height=${window.screen.availHeight}`
  const finestra = window.open('', NOME_FINESTRA_POSTA, misure)
  if (!finestra) return false
  let altrove = true
  try { altrove = finestra.location.pathname !== PERCORSO_FINESTRA_POSTA } catch { /* altra origine: si riporta alla posta */ }
  if (altrove) finestra.location.href = PERCORSO_FINESTRA_POSTA
  finestra.focus()
  return true
}

/**
 * «Torna al gestionale» dalla finestra: in primo piano il gestionale che l'ha aperta, e questa si chiude (il
 * compositore con un testo a meta' chiede conferma, come alla chiusura della scheda). Se quel gestionale non
 * c'e' piu', o la finestra non l'ha aperta un clic, il gestionale si apre qui.
 */
export function tornaAlGestionale(): void {
  const origine = window.opener as Window | null
  let aperta = false
  try { aperta = !!origine && !origine.closed && origine.location.origin === window.location.origin } catch { aperta = false }
  // Con l'opener la finestra l'ha aperta uno script, e il browser ne consente la chiusura.
  if (aperta) {
    origine!.focus()
    window.close()
  } else {
    window.location.assign('/posta')
  }
}
